const mutations = {
  GET_CONTABILISTA(state) {
    return state.contabilista;
  },

  SET_CONTABILISTA(state, contabilista) {
    state.contabilista = contabilista;
  },
};

export default mutations;
